import React from 'react';
import { Helmet } from './components/common/Helmet';
import { useLocation } from 'react-router-dom';

const seoContent: { [key: string]: { title: string; description: string; keywords: string } } = {
    '/': {
        title: "Consultant Neurosurgeon in Noida & Greater Noida | Dr. Gangesh Gunjan",
        description: "Dr. Gangesh Gunjan, Consultant Neurosurgeon serving Noida, Greater Noida, Western UP & Delhi NCR. 12+ years experience in brain, spine and nerve surgeries at Sarvodaya Hospital.",
        keywords: "neurosurgeon Noida, brain specialist Noida, spine surgeon Greater Noida, nerve disorder treatment, Dr. Gangesh Gunjan"
    },
    '/top-neurosurgeon-in-bishanpura': {
        title: "Neurosurgery Consultation for Bishanpura | Dr. Gangesh Gunjan",
        description: "Neurosurgical evaluations and care for patients from Bishanpura with Dr. Gangesh Gunjan. Specialized care for brain, spine, and nerve disorders at Sarvodaya Hospital.",
        keywords: "neurosurgeon Bishanpura, brain surgery Bishanpura, spine specialist, Dr. Gangesh Gunjan"
    },
    '/expert-neurosurgeon-prithvi-vihar': {
        title: "Neurosurgical Care for Prithvi Vihar | Dr. Gangesh Gunjan",
        description: "Dr. Gangesh Gunjan provides specialized neurosurgical care for patients from Prithvi Vihar. Comprehensive evaluation for brain tumors, spinal disorders, and nerve conditions.",
        keywords: "neurosurgeon Prithvi Vihar, brain tumor care, spinal surgery consultation, Dr. Gangesh Gunjan"
    },
    '/best-brain-and-spine-surgeon-hapur': {
        title: "Brain & Spine Neurosurgical Care for Hapur | Dr. Gangesh Gunjan",
        description: "Specialized neurosurgical consultations for patients from Hapur with Dr. Gangesh Gunjan. Care for brain injuries, spinal disorders, and peripheral nerve conditions.",
        keywords: "neurosurgeon Hapur, brain injury care, spine specialist Hapur, Dr. Gangesh Gunjan"
    },
    '/leading-neurosurgeon-bulandshahr': {
        title: "Neurosurgery Consultations for Bulandshahr | Dr. Gangesh Gunjan",
        description: "Dr. Gangesh Gunjan offers dedicated neurosurgical evaluations for patients from Bulandshahr. Specialized care for complex brain, spine, and nerve disorders.",
        keywords: "neurosurgeon Bulandshahr, brain disorder consultation, spine care Bulandshahr, Dr. Gangesh Gunjan"
    },
    '/best-neurosurgeon-in-greater-noida': {
        title: "Consultant Neurosurgeon in Greater Noida | Dr. Gangesh Gunjan",
        description: "Specialized neurosurgical care in Greater Noida West with Dr. Gangesh Gunjan. Consultations for minimally invasive spine surgery, cranial disorders, and peripheral nerves.",
        keywords: "neurosurgeon Greater Noida, brain surgery Greater Noida, spine specialist Greater Noida, Dr. Gangesh Gunjan"
    }
};

const SEOHelmet: React.FC = () => {
    const location = useLocation();
    const { title, description, keywords } = seoContent[location.pathname] || seoContent['/'];

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <meta name="robots" content="index, follow" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://drgangeshgunjanneuro.com/" />
            <meta property="og:location" content="Delhi NCR, Noida, Greater Noida, Mayur Vihar, Ashok Nagar, Hapur, Bulandshahr, Prithvi Vihar, Bishanpura" />
        </Helmet>
    );
};

export default SEOHelmet;